export const PrivateMobileThree = () => {
    return <div className="pt-[42px] [background:linear-gradient(180deg,rgba(255,255,255,1)_0%,rgba(247.94,246.21,255,1)_34.135%,rgba(232.12,243.25,255,1)_66.346%,rgba(255,255,255,1)_100%)] px-[34px]">
        <div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">
            企业私有化组网
            <div>
                为企业打造一张自己的专有网络
            </div>
        </div>
        <div className="mt-[13px] text-[10px] font-regular text-[#FFFFFF] w-[137.2px] h-[22.56px] flex flex-row justify-start items-center gap-[3.84px] px-[3.2px] py-[1.28px] rounded-[3.2px] [background:linear-gradient(90deg,rgba(97,155,255,1),rgba(198,225,255,0)_100%)]">
            私有化组网服务介绍
        </div>

        <div className="text-[10px] font-light text-[rgba(51,51,51,1)] mt-[13px]">
            通过光年K-WAN组网方案，帮助出海企业快速的搭建一张自己的全球专用网络。组网中使用的云服务、国际专线等资源，除了整合企业自身现有的资源外，外采资源服均可以直接与对应服务商直接签约合作，保证资源的实际归属管理权，我们提供优质的高性价比资源渠道、技术搭建与后续维护迭代服务。
        </div>
        <div className="flex justify-between items-center ">
            <div className="w-[82px] h-[28px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[4px] flex items-center justify-center ">
                <a
                    href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
                    target="_blank"
                >
                    <div className=" font-normal text-[12px] text-[#FFFFFF]">
                        联系部署
                    </div>
                </a>
            </div>
            <img
                className="w-[118px] h-[99px] min-w-[118px] min-h-[99px]"
                src="/imgs/private/4.png"
            />
        </div>
    </div>
}